// extracted by mini-css-extract-plugin
module.exports = {"layer":"SiteShot_layer__VzweT","frame":"SiteShot_frame__mnIQ2","image":"SiteShot_image__Zp1bD"};